<template>
  <div class="leaderboardShort" id="leaderboards">
    <div class="title">Leaderboard (Short Montages)</div>
    <ul class="tabList">
      <li :class="{ active: activeTabShort === 0 }" @click="setActiveTabShort(0)"><b></b>Form</li>
      <li :class="{ active: activeTabShort === 1 }" @click="setActiveTabShort(1)"><b></b>Chart</li>
    </ul>
    <div class="board_tabs_Short">
      <div class="item" v-if="activeTabShort === 0">
        <div class="table_wrapper">
          <el-table
            class="Leaderboard_table"
            :data="tableDataShort"
            :default-sort="{ prop: 'Avg', order: 'descending' }"
            style="width: 100%"
            max-height="500"
            @sort-change="handleSortChange"
          >
            <el-table-column label="" width="50" label-class-name="label-class-name_1">
              <template slot-scope="scope">
                {{ scope.$index + 1 }}
              </template>
            </el-table-column>
            <el-table-column prop="methods" :render-header="renderHeader('Methods')" width="160"></el-table-column>
            <el-table-column label="Short Object Needle Grounding">
              <el-table-column prop="objRecall07" sortable :render-header="renderHeader('Recall@1x,<br>tIoU=0.7')" :formatter="formatNumber" width="160"></el-table-column>
              <el-table-column prop="objRecall05" sortable :render-header="renderHeader('Recall@1x,<br>tIoU=0.5')" :formatter="formatNumber" width="160"></el-table-column>
              <el-table-column
                prop="objmAP"
                sortable
                :render-header="renderHeader('Average<br>&nbsp;&nbsp;&nbsp;&nbsp;mAP')"
                :formatter="formatNumber"
                width="140"
              ></el-table-column>
            </el-table-column>
            <el-table-column label="Short Scene Needle Grounding">
              <el-table-column prop="sceneRecall07" sortable :render-header="renderHeader('Recall@1x,<br>tIoU=0.7')" :formatter="formatNumber" width="160"></el-table-column>
              <el-table-column prop="sceneRecall05" sortable :render-header="renderHeader('Recall@1x,<br>tIoU=0.5')" :formatter="formatNumber" width="160"></el-table-column>
              <el-table-column
                prop="scenemAP"
                sortable
                :render-header="renderHeader('Average<br>&nbsp;&nbsp;&nbsp;&nbsp;mAP')"
                :formatter="formatNumber"
                width="140"
              ></el-table-column>
            </el-table-column>
            <el-table-column prop="Avg" sortable :render-header="renderHeader('Avg Recall@1x,<br>tIoU=0.7')" width="190" :formatter="formatNumber"></el-table-column>
          </el-table>
        </div>
      </div>
      <div class="item" v-if="activeTabShort === 1">
        <LineChartShort></LineChartShort>
      </div>
    </div>
  </div>
</template>

<script>
import LineChartShort from "./LineChartShort.vue";
export default {
  name: "LeaderboardShort",
  components: { LineChartShort },
  data() {
    return {
      activeTabShort: 0,
      tableDataShort: [
        {
          methods: "LLaVA-Video-7B",
          objRecall07: 1.1,
          objRecall05: 1.9,
          objmAP: 11.27,
          sceneRecall07: 2.34,
          sceneRecall05: 4.07,
          scenemAP: 19.48,
          Avg: 1.72,
        },
        {
          methods: "LongVA-7B",
          objRecall07: 1.2,
          objRecall05: 4.49,
          objmAP: 18.19,
          sceneRecall07: 2.54,
          sceneRecall05: 6.51,
          scenemAP: 21.87,
          Avg: 1.87,
        },
        {
          methods: "VILA1.5-13B",
          objRecall07: 0.8,
          objRecall05: 1.9,
          objmAP: 4.72,
          sceneRecall07: 3.36,
          sceneRecall05: 6.21,
          scenemAP: 14.77,
          Avg: 2.08,
        },
        {
          methods: "Oryx-34B",
          objRecall07: 2.69,
          objRecall05: 8.88,
          objmAP: 34.95,
          sceneRecall07: 5.39,
          sceneRecall05: 13.84,
          scenemAP: 41.4,
          Avg: 4.04,
        },
        {
          methods: "MiniCPM v2.6-8B",
          objRecall07: 4.49,
          objRecall05: 10.68,
          objmAP: 36.94,
          sceneRecall07: 3.87,
          sceneRecall05: 12.61,
          scenemAP: 41.75,
          Avg: 4.18,
        },
        {
          methods: "VILA1.5-40B",
          objRecall07: 4.49,
          objRecall05: 10.88,
          objmAP: 27.5,
          sceneRecall07: 6.82,
          sceneRecall05: 16.68,
          scenemAP: 40.84,
          Avg: 5.66,
        },
        {
          methods: "Moment-DETR",
          objRecall07: 7.09,
          objRecall05: 17.17,
          objmAP: 40.78,
          sceneRecall07: 10.38,
          sceneRecall05: 23.19,
          scenemAP: 51.2,
          Avg: 8.74,
        },
        {
          methods: "LLaVA-Video-72B",
          objRecall07: 8.88,
          objRecall05: 18.36,
          objmAP: 40.4,
          sceneRecall07: 12.31,
          sceneRecall05: 22.08,
          scenemAP: 41.89,
          Avg: 10.6,
        },
        {
          methods: "E.T. Chat-3.8B",
          objRecall07: 9.72,
          objRecall05: 21.54,
          objmAP: 38.23,
          sceneRecall07: 14.94,
          sceneRecall05: 26.82,
          scenemAP: 45.56,
          Avg: 12.33,
        },
        {
          methods: "UniVTG",
          objRecall07: 13.0,
          objRecall05: 24.7,
          objmAP: 53.16,
          sceneRecall07: 19.65,
          sceneRecall05: 34.42,
          scenemAP: 64.19,
          Avg: 16.33,
        },
        {
          methods: "LongVU-7B",
          objRecall07: 15.37,
          objRecall05: 31.44,
          objmAP: 63.06,
          sceneRecall07: 19.43,
          sceneRecall05: 34.18,
          scenemAP: 68.48,
          Avg: 17.4,
        },
        {
          methods: "Time-R1-3B",
          objRecall07: 15.27,
          objRecall05: 32.53,
          objmAP: 63.84,
          sceneRecall07: 22.38,
          sceneRecall05: 40.18,
          scenemAP: 72.85,
          Avg: 18.82,
        },
        {
          methods: "Time-R1-7B",
          objRecall07: 22.36,
          objRecall05: 38.02,
          objmAP: 68.25,
          sceneRecall07: 29.79,
          sceneRecall05: 44.86,
          scenemAP: 74.76,
          Avg: 26.03,
        },
        {
          methods: "Qwen2.5-VL-7B",
          objRecall07: 24.45,
          objRecall05: 32.63,
          objmAP: 57.22,
          sceneRecall07: 29.7,
          sceneRecall05: 41.71,
          scenemAP: 65.62,
          Avg: 27.08,
        },
        {
          methods: "Qwen2.5-VL-72B",
          objRecall07: 28.04,
          objRecall05: 37.62,
          objmAP: 61.01,
          sceneRecall07: 31.11,
          sceneRecall05: 43.13,
          scenemAP: 66.66,
          Avg: 29.69,
        },
        {
          methods: "Gemini-1.5-Flash-8B",
          objRecall07: 41.86,
          objRecall05: 50.85,
          objmAP: 73.89,
          sceneRecall07: 55.7,
          sceneRecall05: 63.44,
          scenemAP: 82.38,
          Avg: 48.78,
        },
        {
          methods: "Qwen-VL-Max",
          objRecall07: 54.46,
          objRecall05: 63.69,
          objmAP: 82.77,
          sceneRecall07: 56.63,
          sceneRecall05: 64.8,
          scenemAP: 83.03,
          Avg: 55.55,
        },
        {
          methods: "Gemini-1.5-Flash-002",
          objRecall07: 62.64,
          objRecall05: 73.73,
          objmAP: 85.24,
          sceneRecall07: 72.1,
          sceneRecall05: 81.26,
          scenemAP: 90.15,
          Avg: 67.37,
        },
        {
          methods: "GPT-4o",
          objRecall07: 64.07,
          objRecall05: 74.85,
          objmAP: 88.56,
          sceneRecall07: 71.41,
          sceneRecall05: 81.18,
          scenemAP: 89.91,
          Avg: 67.74,
        },
        {
          methods: "Gemini-1.5-Pro-002",
          objRecall07: 65.83,
          objRecall05: 78.22,
          objmAP: 89.81,
          sceneRecall07: 74.85,
          sceneRecall05: 85.54,
          scenemAP: 92.85,
          Avg: 70.34,
        },
        {
          methods: "Human Experts",
          objRecall07: 93.62,
          objRecall05: 96.1,
          objmAP: 95.31,
          sceneRecall07: 94.33,
          sceneRecall05: 95.39,
          scenemAP: 96.31,
          Avg: 93.98,
        },
      ],
    };
  },
  methods: {
    setActiveTabShort(index) {
      this.activeTabShort = index;
    },
    renderHeader(label) {
      return (h) => {
        return h("span", {
          domProps: {
            innerHTML: label,
          },
        });
      };
    },
    handleSortChange({ prop, order }) {
      if (order === "ascending") {
        this.tableDataShort.sort((a, b) => this.sortData(a, b, prop));
      } else if (order === "descending") {
        this.tableDataShort.sort((a, b) => this.sortData(b, a, prop));
      }
    },
    sortData(a, b, prop) {
      if (typeof a[prop] === "string" && typeof b[prop] === "string") {
        return a[prop].localeCompare(b[prop]);
      }
      return a[prop] - b[prop];
    },
    formatNumber(row, column, cellValue) {
      const value = parseFloat(cellValue || 0);
      return value.toFixed(2);
    },
  },
};
</script>

<style lang="scss" scoped>
$tablet: 1024px; // 平板及以下（≤1024px）
$mobile: 768px; // 移动端及以下（≤768px）
.leaderboardShort {
  margin: 40px auto 0px;
  width: 100%;
  position: relative;
  padding: 0 15px;

  .title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    color: #ffffff;
    text-align: center;
    font-style: normal;
    position: relative;
    z-index: 1;
  }

  .tabList {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 10px;
    margin-bottom: 20px;
    padding: 0;

    li {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 36px;
      width: 80px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 14px;
      color: #d0d0d0;
      text-align: left;
      font-style: normal;
      border: 1px solid rgba(208, 208, 208, 1);
      cursor: pointer;
      list-style: none;

      &:nth-child(1) {
        border-top-left-radius: 20px;
        border-bottom-left-radius: 20px;
        border-right-color: transparent;

        b {
          background: url("../../assets/images/fill_1.png") no-repeat;
          background-size: 100% 100%;
          width: 14px;
          height: 13px;
          margin-right: 5px;
        }
      }

      &:nth-child(2) {
        border-top-right-radius: 20px;
        border-bottom-right-radius: 20px;
        border-left-color: transparent;

        b {
          background: url("../../assets/images/fill_4.png") no-repeat;
          background-size: 100% 100%;
          width: 14px;
          height: 13px;
          margin-right: 5px;
        }
      }

      &.active {
        color: rgba(255, 98, 31, 1);
        border: 1px solid rgba(255, 98, 31, 1);

        &:nth-child(1) {
          b {
            background: url("../../assets/images/fill_2.png") no-repeat;
          }
        }

        &:nth-child(2) {
          b {
            background: url("../../assets/images/fill_3.png") no-repeat;
          }
        }
      }
    }
  }

  .board_tabs_Short {
    width: 100%;

    .item {
      width: 100%;
      height: auto;
      overflow: auto !important;
    }
  }

  .table_wrapper {
    overflow-x: auto;
  }
}

// 平板适配（≤1024px）
@media (max-width: $tablet) {
  .leaderboardShort {
    .title {
      font-size: 36px;
      margin-bottom: 25px;
    }

    .tabList li {
      width: 75px;
      font-size: 13px;
    }

    .chart_wrapper {
      height: 400px; // 缩小图表高度
    }

    // 表格字体缩小，节省空间
    ::v-deep .el-table {
      font-size: 12px;

      .el-table__header-wrapper .cell {
        font-size: 11px;
        height: 45px; // 增加表头高度，避免文字重叠
      }

      .el-table__body-wrapper .el-table__cell {
        padding: 10px 0; // 减少单元格内边距
      }
    }
  }
}

// 移动端适配（≤768px）
@media (max-width: $mobile) {
  .leaderboardShort {
    .title {
      font-size: 26px;
      margin-bottom: 20px;
    }

    .tabList {
      margin-bottom: 15px;
    }

    .board_tabs_Short .item {
    }
  }
}

// 表格样式穿透
::v-deep {
  .el-table.Leaderboard_table {
    background-color: transparent;
    border-collapse: collapse;
    border: none !important;

    th.el-table__cell,
    td.el-table__cell {
      border: none !important;
    }

    .el-table__header-wrapper {
      .el-table__header {
        thead {
          color: #e2e2e2;

          tr {
            background: transparent;

            &:first-child {
              th.el-table__cell.is-leaf {
                vertical-align: bottom;
              }
            }
          }
        }
      }

      th.el-table__cell.is-leaf {
        border-bottom: 1px solid transparent;
      }

      th.el-table__cell {
        background-color: transparent;
        padding: 0px;

        .cell {
          display: flex;
          align-items: center;
          justify-content: center;
          height: 40px;
          font-size: 12px;

          .caret-wrapper {
            margin-left: 5px;
          }
        }
      }

      .descending .sort-caret.descending {
        border-top-color: rgb(255, 98, 31);
      }

      .ascending .sort-caret.ascending {
        border-bottom-color: rgb(255, 98, 31);
      }
    }

    .el-table__body-wrapper {
      .el-table__body {
        color: #e0e0e0;
        font-size: 12px;

        tr:nth-child(1) {
          color: #ff401f;
        }

        tr:nth-child(2) {
          color: #ff8653;
        }

        tr:nth-child(3) {
          color: #ffdc3c;
        }

        tr:nth-child(odd) {
          background: rgba(216, 216, 216, 0.1);
          border-radius: 16px 0px 0px 16px;

          td:nth-child(1) {
            border-radius: 16px 0px 0px 16px;
          }
        }

        tr:nth-child(even) {
          background: transparent;
          border-radius: 16px 0px 0px 16px;

          td:nth-child(1) {
            border-radius: 16px 0px 0px 16px;
          }
        }

        tr:hover > td.el-table__cell {
          background: rgba(216, 216, 216, 0.2);
          border-bottom: none !important;
        }

        .el-table__cell {
          padding: 12px 0;
          border-bottom: 1px solid transparent;
        }

        tr > .el-table__cell:nth-child(n + 3) {
          text-align: center !important;
        }
      }
    }

    .el-table--border::after,
    .el-table--group::after,
    &::before {
      background: transparent;
    }

    &::before,
    &::after {
      display: none !important;
    }
    // 滚动条样式
    .el-table__body-wrapper::-webkit-scrollbar {
      width: 5px;
      height: 5px;
    }

    .el-table__body-wrapper::-webkit-scrollbar-thumb {
      background: rgba(216, 216, 216, 0.4);
      border-radius: 3px;
    }

    .el-table__body-wrapper::-webkit-scrollbar-track {
      background: transparent;
    }
  }
}
</style>
